import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { Text, Button } from '@beef/ui-kit';
import { DETALIZATION_MODAL_COMMON } from 'constants/detalization';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const MailSection = ({ email, onClick, isConfirmed }) => (
  <div className={cx('mail-wrapper', { 'mail-wrapper--confirmed': !isConfirmed })}>
    {email?.length > 0 && (
      <div className={cx('mail-caption-wrapper')}>
        <Text size="size5-r-l">{email}</Text>
        {!isConfirmed && <Text size="size7-m" color="scarlet">Почта не потверждена</Text>}
      </div>
    )}
    <Button
      variant="plain"
      onClick={onClick}
    >
      <Text size="size5-b">
        {DETALIZATION_MODAL_COMMON.CHANGE_MAIL_BUTTON_CAPTION}
      </Text>
    </Button>
  </div>
);

MailSection.propTypes = {
  email: PropTypes.string,
  onClick: PropTypes.func,
  isConfirmed: PropTypes.bool,
};
